// BottomNav.js

import React from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Link, useLocation } from "react-router-dom";
import SchedulerIcon from "../../assets/svg/Scheduler.svg";
import PrePlantingIcon from "../../assets/svg/NewPraplanting.svg";
import PlantingIcon from "../../assets/svg/planting.svg";
import DailyActivityIcon from "../../assets/svg/DayWiseActivity2.svg";
import HarvestingIcon from "../../assets/svg/HarvestingActivity.svg";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles(() => ({
	bottomNavigation: {
		position: "fixed",
		bottom: 5,
		width: "100%",
		height: 30,
		backgroundColor: "#FFF",
		marginBottom:"55px"
	},
	icon: {
		width: 40,
		height: 40,
		marginBottom: 10,
	},
	label: {
		fontSize: "12px",
		textAlign: "center",
		marginTop: 2,
	},
}));

const BottomNav = () => {
	const classes = useStyles();
	const location = useLocation();
	const { t } = useTranslation();
	let farmerPlotId = "";
	if (localStorage.getItem("farmerPlotId")) {
		farmerPlotId = localStorage.getItem("farmerPlotId");
	}

	const navItems = [
		{ label: t("Scheduler"), to: `/schedule-activity/${farmerPlotId}`, icon: SchedulerIcon },
		{ label: t("Pre Planting Activity"), to: "/activity/PrePlanting/", icon: PrePlantingIcon },
		{ label: t("Planting Activity"), to: "/activity/planting-activity/", icon: PlantingIcon },
		{ label: t("Daily Activity"), to: "/activity/daywise-activity/", icon: DailyActivityIcon },
		{ label: t("Harvesting"), to: "/activity/harvesting/", icon: HarvestingIcon },
	];
	return (
		<div>
			<BottomNavigation className={classes.bottomNavigation} style={{ height: "80px" }}>
				{navItems.map((item, index) => (
					<div key={index}>
						<BottomNavigationAction
							showLabel
							icon={<img src={item.icon} alt={item.label} className={classes.icon} style={{ marginTop: "10px" }} />}
							label={
								<Typography variant='body2' className={classes.label} style={{ opacity: 1, fontSize: "8px" }}>
									{t(item.label)}
								</Typography>
							}
							component={Link}
							to={item.to}
							style={{
								backgroundImage: location.pathname === item.to ? "url('path_to_active_image')" : "none",
								// backgroundColor: location.pathname === item.to ? "aliceblue" : "transparent",
								color: location.pathname === item.to ? "#000" : "inherit",
								padding: "8px",
								filter: location.pathname === item.to ? "brightness(0.5) saturate(0%)" : "none",
							}}
						/>
					</div>
				))}
			</BottomNavigation>
		</div>
	);
};

export default BottomNav;
